export enum QueueStateEnum {
  Waiting = 'در حال انتظار', // در حال انتظار
  Called = 'فراخوان شده', // فرخوان شده
  Recall = 'فراخوان مجدد شده', // فرخوان مجدد
  DisplayedOnMonitor = 'نمایش در صفحه نمایشگر', //  نمایش داده شده در نمایشگر
  TransfredToAnotherQueue = 'انتقال به صف بعدی', // انتقال به صف دیگر
  Absent = 'غایب', // غایب
}
